export const getGoogleReviewUrl = (placeId: string) =>
  `https://search.google.com/local/reviews?placeid=${placeId}`;
